<template>
  <SideMenuBase :menuGroups="menuGroups" />
</template>

<script setup>
import SideMenuBase from '@/components/layout/SideMenuBase.vue'

const menuGroups = [
  {
    title: 'Manage',
    items: [
      { label: 'Users', path: '/admin/manage-users', requiredPermission: 'admin.manage.users' },
      { label: 'Roles', path: '/admin/manage-roles', requiredPermission: 'admin.manage.roles' },
      { label: 'Permissions', path: '/admin/manage-permissions', requiredPermission: 'admin.manage.permissions' },
      { label: 'Password Resets', path: '/admin/manage-password-resets', requiredPermission: 'admin.manage.password_resets' }
    ]
  },
  {
    title: 'Configuration',
    items: [
      { label: 'Operations', path: '/admin/config-operations', requiredPermission: 'admin.configure.operations' },
      { label: 'Inventory', path: '/admin/config-inventory', requiredPermission: 'admin.configure.inventory' },
    ]
  }
]
</script>
